import { IForm } from '@/base-ui/form'
export const modalConfig: IForm = {
  colLayout: { span: 24 },
  formItems: [
    {
      field: 'province',
      label: '省份',
      placeholder: '请输入省份',
      type: 'input',
      rules: [
        { required: true, message: '省份为必填项', trigger: 'blur' }
      ]
    },
    {
      field: 'city',
      type: 'input',
      label: '城市',
      placeholder: '请输入城市',
      rules: [
        { required: true, message: '城市为必填项', trigger: 'blur' }
      ]
    },
    {
      field: 'price',
      type: 'input',
      label: '价格',
      placeholder: '请输入价格(分)',
      rules: [
        { required: true, message: '价格为必填项', trigger: 'blur' }
      ]
    }
  ]
}
